import { render, staticRenderFns } from "./EnquiryFilterChips.vue?vue&type=template&id=309386fc&scoped=true&"
import script from "./EnquiryFilterChips.vue?vue&type=script&lang=js&"
export * from "./EnquiryFilterChips.vue?vue&type=script&lang=js&"
import style0 from "./EnquiryFilterChips.vue?vue&type=style&index=0&id=309386fc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "309386fc",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VChip } from 'vuetify/lib/components/VChip';
installComponents(component, {VChip})
